export default __webpack_public_path__ + "static/media/LouverLevel4.7bd3a99d.svg";